<div class="notification-container">
  <div *ngFor="let item of notifications" class="notification notification--{{item.type}}" [@enterAnimation]
       (keydown)="dismissNotification(item.id)" (click)="dismissNotification(item.id)">
    <div class="notification__content">
      <h2 *ngIf="item.config.title" class="notification__title">
        {{item.config.title | l10n}}
      </h2>
      <div class="notification__message">{{ item.message | l10n }}</div>
    </div>

    <button class="notification__action" *ngIf="item.config.action" (click)="handleActionClick($event, item)">
      {{item.config.action.label | l10n}}
    </button>

    <span class="notification__close"></span>
  </div>
</div>

